// آخر المنتجات اللي العميلة فتحتها (في المتصفح بس) — الأحدث أولاً.
// بنستخدمها لاقتراح منتجات مشابهة في الرئيسية وصفحة المنتج.
const KEY = 'recently_viewed';
const MAX = 12;
const EVENT = 'recently-viewed-change';

export const getRecentlyViewed = () => {
  try {
    const ids = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(ids) ? ids.filter((id) => Number.isInteger(id)) : [];
  } catch {
    return [];
  }
};

export const addRecentlyViewed = (id) => {
  const pid = Number(id);
  if (!Number.isInteger(pid)) return;
  try {
    const ids = [pid, ...getRecentlyViewed().filter((x) => x !== pid)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(ids));
    window.dispatchEvent(new Event(EVENT));
  } catch {
    /* التخزين غير متاح */
  }
};

export const onRecentlyViewedChange = (cb) => {
  window.addEventListener(EVENT, cb);
  window.addEventListener('storage', cb);
  return () => {
    window.removeEventListener(EVENT, cb);
    window.removeEventListener('storage', cb);
  };
};
